<template>
  <h1 class="font-bold text-3xl mb-4">Account created</h1>
  <div>a verificion email has been sent to your mailbox</div>
</template>
